import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { AuthGuard } from "../guards/auth.guard";
import { ForgotPasswordComponent } from "./forgot-password.component";

const routes: Routes = [
    {
        path: 'forgotPassword',
        component: ForgotPasswordComponent,
        canLoad: [AuthGuard],
    }
]
@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule]
})
export class ForgotPasswordRoutingModule {}